import { BucketError, BucketLoading } from '../../regional/BucketStates';
import { CheckInModal } from '../../workshops/detail/CheckInModal';
import { useWorkshop } from '../../workshops/useWorkshop';

/** Polled while open so crew checking in the same workshop see each other's
 *  check-ins, as the detail page does. */
const CHECK_IN_POLL_MS = 4000;

interface MyScheduleCheckInProps {
  workshopId: string;
  onClose: () => void;
}

/** The check-in modal opened from My schedule. It loads the workshop's roster
 *  and closes back onto the schedule rather than onto the detail page. Until
 *  the roster arrives, or if it cannot load, a small dialog says so. */
export default function MyScheduleCheckIn({ workshopId, onClose }: MyScheduleCheckInProps) {
  const {
    data: workshop,
    isError,
    error,
  } = useWorkshop(workshopId, {
    pollMs: CHECK_IN_POLL_MS,
  });
  if (workshop) {
    return <CheckInModal workshop={workshop} onClose={onClose} returnsTo="My schedule" />;
  }

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Check in"
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: 'rgba(15, 25, 18, 0.35)' }}
      onClick={onClose}
    >
      <div
        className="nb-card flex w-full max-w-sm flex-col gap-3"
        onClick={(e) => e.stopPropagation()}
      >
        {isError ? <BucketError error={error} /> : <BucketLoading />}
        <button type="button" className="nb-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
